<template>
    <div class="flex items-center">
        <div class="flex items-center">
            <img src="@/assets/logo2.png" alt="" width="25">
            <div class="fs13 ml5 bold a70">
                {{数据后台}}
            </div>
        </div>
        <div class="flex-width ml40">
            <el-menu size="mini"
                :default-active="activeIndex"
                class="el-menu-demo"
                mode="horizontal"
                @select="handleSelect"
                background-color="#ffffff"
                text-color="#33476e"
                active-text-color="#52be00">
                <el-menu-item index="6">{{总览}}</el-menu-item>
                <el-submenu index="1">
                    <template slot="title">{{数据中心}}</template>
                    <el-menu-item index="1-1" v-if="privileges['1-1']">{{投放数据}}</el-menu-item>
                    <el-menu-item index="1-2" v-if="privileges['1-2']">{{收益数据}}</el-menu-item>
                    <el-menu-item index="1-3">数据报表</el-menu-item>
                    <el-menu-item index="1-4">消耗数据</el-menu-item>
                </el-submenu>
                <el-menu-item index="2" v-if="privileges['2']">{{应用中心}}</el-menu-item>
                <el-menu-item index="3" v-if="privileges['3']">{{广告户管理}}</el-menu-item>
                <el-menu-item index="4" v-if="privileges['4']">{{APP户管理}}</el-menu-item>
                <el-menu-item index="5" v-if="privileges['5']">{{账号管理}}</el-menu-item>
                <el-menu-item index="7" v-if="privileges['7']">{{投放管理}}</el-menu-item>
                <el-menu-item index="8">热更管理</el-menu-item>
            </el-menu>
        </div>
        <div>
            <el-dropdown @command="onChangeLocale">
                <span class="el-dropdown-link">
                    <span v-if="language=='zh'">中文</span>
                    <span v-else>EN</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="zh">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="ml20">
            <el-dropdown @command="onChangeCommand">
                <span class="el-dropdown-link">
                    <span>{{ admin_name }}</span>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="alter">{{修改密码}}</el-dropdown-item>
                    <el-dropdown-item command="exit">{{注销账号}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dialog
                :title="修改密码"
                :visible.sync="alterPasswordVisiable"
                width="30%">
                <span>
                    <el-input v-model="alterForm.password" :placeholder="请输入新密码"></el-input>
                    <el-input v-model="alterForm.password2" class="mt10" :placeholder="请再次输入新密码"></el-input>
                </span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="alterPasswordVisiable = false">{{取消}}</el-button>
                    <el-button type="primary" @click="confirmChangePwd">{{确定}}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        data() {
            return {
                activeIndex: '1-1',
                menu: {
                    "1-1": {
                        path: "/gamedata"
                    },
                    "1-2": {
                        path: "/revenue"
                    },
                    "1-3": {
                        path: "/gamereports"
                    },
                    "1-4": {
                        path: "/costreports"
                    },
                    "2": {
                        path: "/apps"
                    },
                    "3": {
                        path: "/advertisers"
                    },
                    "4": {
                        path: "/app_gallery"
                    },
                    "5": {
                        path: "/accounts"
                    },
                    "6": {
                        path: "/total"
                    },
                    "7": {
                        path: "/promotion"
                    },
                    "8": {
                        path: "/patch"
                    }
                },
                alterPasswordVisiable: false,
                alterForm: {
                    password: "",
                    password2: ""
                }
            };
        },
        computed: {
			...mapGetters([
				'admin_name',"is_set_password", 'privileges', "language", "数据后台","数据中心","投放数据","收益数据","应用中心","广告户管理","APP户管理","账号管理","总览", "注销账号","修改密码","确定","取消","请输入新密码","请再次输入新密码", "投放管理"
			])
		},
        created() {
            let i = window.location.href.lastIndexOf("/");
            let name = window.location.href.substring(i);
            for (let key in this.menu) {
                let vo = this.menu[key];
                if (vo.path == name) {
                    this.activeIndex = key;
                    break;
                }
            }
            this.getPrivileges();

            setTimeout(() => {
                if (!this.is_set_password) {
                    this.alterPasswordVisiable = true;
                }
            }, 1000);
        },
        methods: {
            ...mapActions(["setPrivileges", "setLanguage", "setIsSetPassword"]),
            handleSelect(key, keyPath) {
                let vo = this.menu[key];
                this.$router.push(vo.path);
            },
            async getPrivileges() {
                let rs = await this.$api.getPrivileges();
                if (rs.err == 0) {
                    let prev = rs.data;
                    let privileges = {};
                    for (let key of prev.split(",")) {
                        privileges[key] = true;
                    }
                    // console.log(privileges)
                    this.setPrivileges(privileges);
                }
            },
            onChangeLocale(e) {
                this.setLanguage(e);
            },
            onChangeCommand(cmd) {
                if (cmd == "exit") {
                    this.$router.push("/login");
                    this.$api.request_body.logout();
                } else if (cmd == "alter") {
                    this.alterPasswordVisiable = true;
                }
            },
            async confirmChangePwd() {
                if (this.alterForm.password == this.alterForm.password2 && this.alterForm.password != "") {
                    let rs = await this.$api.changePassword(this.alterForm.password);
                    if (rs.err == 0) {
                        this.setIsSetPassword(true);
                        this.$message({
                            type: "success",
                            message: "修改成功，请重新登录"
                        })
                        this.alterPasswordVisiable = false;
                        this.alterForm.password = "";
                        this.alterForm.password2 = "";
                        setTimeout(() => {
                            this.$router.push("/login");
                            this.$api.request_body.logout();
                        }, 1000);
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: "密码输入不相同"
                    })
                }
            }
        }
    }
</script>

<style>
.el-menu-demo {
    height: 50px;
}
.el-menu-item {
    height: 50px!important;
    line-height: 50px!important;
}
.el-submenu {
    height: 50px!important;
    line-height: 50px!important;
}
.el-submenu__title {
    height: 50px!important;
    line-height: 50px!important;
}
</style>